import { printHtmlNodesToJsx } from '@utils/ast';
import { glossaryWord } from './atom.glossary-definition.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function GlossaryDefinition(props) {
  return /*#__PURE__*/jsxs("div", {
    className: glossaryWord,
    children: [/*#__PURE__*/jsxs("sup", {
      children: [props.index + 1, " "]
    }), /*#__PURE__*/jsxs("span", {
      "data-term": true,
      children: [printHtmlNodesToJsx(props.glossary.children), ": "]
    }), /*#__PURE__*/jsx("span", {
      "data-definition": true,
      children: printHtmlNodesToJsx(props.definition)
    })]
  });
}

export { GlossaryDefinition };
//# sourceMappingURL=atom.glossary-definition.js.map
